module.exports = __webpack_public_path__ + "img/edit.bb35a296.svg";